// third-party
import { configureStore } from "@reduxjs/toolkit";
import { FormattedMessage } from "react-intl";
import {
  useDispatch as useAppDispatch,
  useSelector as useAppSelector,
} from "react-redux";
import { persistStore } from "redux-persist";
// project imports
import axiosServices from "utils/axios";
import { getErrorCode } from "utils/errors";
import rootReducer from "./reducer";
import { openSnackbar } from "./slices/snackbar";

// ==============================|| REDUX - MAIN STORE ||============================== //
const store = configureStore({
  reducer: rootReducer,
  devTools: false,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false, immutableCheck: false }),
});

axiosServices.interceptors.response.use(
  (response) => {
    // If the response is successful, return it
    return response;
  },
  (error) => {
    // if error is 401 dont show snackbar
    if (error.response && error.response.status === 401) {
      return Promise.reject(error);
    }
    const code = getErrorCode(error);
    console.log(code);
    store.dispatch(
      openSnackbar({
        open: true,
        message: <FormattedMessage id={`errors.${code}`} />,
        variant: "alert",
        alert: {
          color: "error",
          variant: "filled",
        },
        close: false,
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "center",
        },
        transition: "SlideLeft",
      })
    );
    return Promise.reject(error);
  }
);

const persister = persistStore(store);

const { dispatch } = store;

const useDispatch = () => useAppDispatch();
const useSelector = useAppSelector;

export { dispatch, persister, store, useDispatch, useSelector };
